'use client'
import SiteSubheading from '@/app/components/SiteSubheading'
import classNames from 'classnames'
import { EmblaOptionsType } from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import Image from 'next/image'
import { useParams } from 'next/navigation'
import { FC } from 'react'

const partners = [
	{
		logo: '/images/partners/booking.png',
		name: 'Booking.com',
	},
	{
		logo: '/images/partners/expedia.png',
		name: 'Expedia',
	},
	{
		logo: '/images/partners/hotels-com.png',
		name: 'Hotels.com',
	},
	{
		logo: '/images/partners/trip-com.png',
		name: 'Trip.com',
	},
	{
		logo: '/images/partners/kayak.png',
		name: 'Kayak',
	},
	{
		logo: '/images/partners/skyscanner.png',
		name: 'Skyscanner',
	},
	{
		logo: '/images/partners/trivago.png',
		name: 'Trivago',
	},
	{
		logo: '/images/partners/travelocity.png',
		name: 'Travlocity',
	},
]

interface PartnersCarouselProps { }
const PartnersCarousel: FC<PartnersCarouselProps> = () => {
	const urlParams = useParams()
	const isRtl = urlParams.lang === 'ar' || urlParams.lang === 'he';
	const options: EmblaOptionsType = {
		loop: true,
		skipSnaps: true,
		slidesToScroll: 1,
		align: 'start',
		direction: isRtl ? 'rtl' : 'ltr',
	}
	const [emblaRef] = useEmblaCarousel(options, [
		Autoplay({ playOnInit: true, delay: 3500 }),
	])

	return (
		<section className="max-lg:pt-8 container max-lg:min-h-[148px] max-sm:py-8 max-sm:px-4 max-sm:min-h-[124px]">
			<SiteSubheading className="text-text-600 max-lg:text-sm lg:hidden mb-6 !p-0 max-sm:hidden" />
			<div className="partners-carousel">
				<div className="embla__viewport" ref={emblaRef}>
					<div className="embla__container">
						{partners.map((partner, index) => (
							<div
								className={classNames('embla__slide', {
									'ps-[3px] xl:ps-[26px]': index !== 0,
								})}
								key={index}
							>
								<div className="embla__slide__image">
									<Image
										src={partner.logo}
										alt={`Logo of ${partner.name}`}
										width={144}
										height={60}
										className="sm:h-full w-auto"
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

export default PartnersCarousel
